import { useDispatch } from "react-redux";

import { HouseRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../common";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import PipedElements from "../PipedElements";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const HomeValueActivity = ({ activity, onReadChange }) => {
  const isPlace = useTheme()?.name === "place-theme";
  const dispatch = useDispatch();

  return (
    <ActivityContainer activity={activity} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={HouseRegularV6}>
            New Home Value
          </CategoryContainer>
        }
        personName={`${activity.data.subjectFirstName} ${activity.data.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField
          label="Address"
          data={`${activity.data?.propertyStreetAddress}${activity.data?.propertyState ? `, ${activity.data?.propertyState}` : ""}${activity.data?.propertyZipCode ? `, ${activity.data?.propertyZipCode}` : ""}`}
        />
        <PipedElements>
          <div className="tw-text-14d">
            {activity.data?.propertyBeds && <DataField label="Bed" data={activity.data?.propertyBeds} />}
            {activity.data?.propertyBaths && <DataField label="Bath" data={activity.data?.propertyBaths} />}
            {activity.data?.propertySqft && <DataField label="SQFT" data={activity.data?.propertySqft} />}
          </div>
        </PipedElements>
        <ActivityBtns
          callHandlr={() => {
            if (activity.personUuid) {
              dispatch(
                setCallParams({ leadUuids: [activity.personUuid], callSource: "Home Value Activity" }),
              );
            }
          }}
          reportHandlr={
            activity.data?.reportUrl
              ? () => {
                  window.open(activity.data?.reportUrl, "_blank");
                }
              : null
          }
        />
      </div>
    </ActivityContainer>
  );
};

export default HomeValueActivity;

HomeValueActivity.propTypes = {
  ...activityCommonPropTypes,
};

HomeValueActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
